<main class="maintenance-page" role="alert" aria-live="assertive">
  <img
    class="maintenance-page__image"
    src="assets/images/maintenance.svg"
    alt=""
  />
  <h1>We'll be back soon</h1>
  <p>{{ maintenanceService.message() }}</p>
  <button
    type="button"
    class="btn btn-primary"
    (click)="tryAgain()"
  >
    Try again
  </button>
</main>
